import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Copy07 = function Copy07(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10.5 2.0028c-.675.0091-1.0803.0482-1.408.2152a2 2 0 0 0-.874.874c-.167.3277-.206.733-.2152 1.408M19.5 2.0028c.6751.0091 1.0803.0482 1.408.2152.3763.1917.6823.4977.874.874.167.3277.2061.733.2152 1.408m0 9c-.0091.675-.0482 1.0803-.2152 1.408a2 2 0 0 1-.874.874c-.3277.167-.7329.2061-1.408.2152M22 8v2m-7.9999-8H16M5.2 22h7.6c1.1201 0 1.6802 0 2.108-.218a2 2 0 0 0 .874-.874C16 20.4802 16 19.9201 16 18.8v-7.6c0-1.1201 0-1.6802-.218-2.108a2 2 0 0 0-.874-.874C14.4802 8 13.9201 8 12.8 8H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 9.5198 2 10.08 2 11.2v7.6c0 1.1201 0 1.6802.218 2.108.1917.3763.4977.6823.874.874C3.5198 22 4.08 22 5.2 22"
    })
  }));
};
export default Copy07;